<template>

    <div>
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="col-3">
                    <catalog-categories></catalog-categories>
                </div>

                <div class="col-6">
                    <h1 class="as-h2 mb-64">Восстановить пароль</h1>

                    <div class="position-relative">
                        <!-- *** STEP 1 *** -->
                        <div v-if="step_1">
                            <div class="mb-32 input-box">
                                <label for="register_phone" :class="{'error-form': $v.login.$error}">Введите номер телефона, который Вы использовали при регистрации*</label>
                                <input id="register_phone" type="text"
                                       placeholder="+"
                                       @input="delayTouch($v.login)"
                                       v-model.trim="login"
                                       v-mask="'+################'">
                                <div class="error-box">
                                    <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.minLength">Проверьте формат введенного номера.</div>
                                    <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.required">Поле обязательно для заполнения</div>
                                </div>
                            </div>


                            <button class="button btn-large" @click="registerStep_1()">Получить код</button>
                        </div>

                        <!-- *** STEP 2 *** -->
                        <div v-if="step_2">
                            <div class="mb-32 input-box">
                                <label for="register_phone_step_2" :class="{'error-form': $v.login.$error}">Введите номер телефона*</label>
                                <input id="register_phone_step_2" type="text"
                                       placeholder="+"
                                       @input="delayTouch($v.login)"
                                       v-model.trim="login"
                                       v-mask="'+################'">
                                <div class="error-box">
                                    <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.minLength">Проверьте формат введенного номера.</div>
                                    <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.required">Поле обязательно для заполнения</div>
                                </div>
                            </div>

                            <div class="mb-32 input-box">
                                <label for="register_code" :class="{'error-form': $v.code.$error}">Введите код, который пришел на ваш номер*</label>
                                <input id="register_code" type="text"
                                       @input="delayTouch($v.code)"
                                       v-model.trim="code">
                                <div class="h6 mb-0 color-text-grey pt-1">Ваш код придет на номер {{login}} в течение 12 сек.</div>
                                <div class="error-box">
                                    <div class="h6 pt-1 error-form" v-if="$v.code.$error && !$v.code.required">Поле обязательно для заполнения</div>
                                </div>
                            </div>

                            <button class="button btn-large" @click="registerStep_2()">Отправить</button>
                        </div>

                        <!-- *** STEP 3 *** -->
                        <div v-if="step_3">
                            <div class="mb-32 input-box">
                                <label for="register_pass" :class="{'error-form': $v.password.$error}">Введите новый пароль*</label>
                                <input id="register_pass" type="password"
                                       @input="delayTouch($v.password)"
                                       v-model.trim="password">
                                <div class="error-box">
                                    <div class="h6 pt-1 error-form" v-if="$v.password.$error && !$v.password.minLength">Пароль должен содержать не менее 8 знаков.</div>
                                    <div class="h6 pt-1 error-form" v-if="$v.password.$error && !$v.password.required">Поле обязательно для заполнения.</div>
                                </div>
                            </div>

                            <div class="mb-32 input-box">
                                <label for="register_pass_repeat" :class="{'error-form': $v.password_confirm.$error}">Введите пароль повторно*</label>
                                <input id="register_pass_repeat" type="password"
                                       @input="delayTouch($v.password_confirm)"
                                       v-model.trim="password_confirm">
                                <div class="error-box">
                                    <div class="h6 pt-1 error-form" v-if="$v.password_confirm.$error && !$v.password_confirm.minLength">Пароли не совпадают.</div>
                                    <div class="h6 pt-1 error-form" v-if="$v.password_confirm.$error && !$v.password_confirm.required">Поле обязательно для заполнения.</div>
                                </div>
                            </div>

                            <button class="button btn-large" @click="registerStep_3()">Сохранить</button>
                        </div>

                        <div v-if="loading" class="loading-box">
                            <b-spinner></b-spinner>
                        </div>
                    </div>

                </div>

                <div class="col-3">
                    <img src="/img/icons/logo_225.svg" alt="Фотопрокат MRental - прокат фото, видео и кинотехники в Минске без залога" class="img-fluid">
                </div>
            </div>
        </div>

    </div>

</template>


<script>
    import { phoneRule, passwordRule, passwordRepeatRule, checkbox, requiredRule } from '../../../services/validation';
    const touchMap = new WeakMap();

    export default {
        data() {
            return {
                login: null,
                password: null,
                password_confirm: null,
                code: null,


                breadcrumb: [
                    {
                        text: 'Главная',
                        to: { name: 'pages-index' }
                    },
                    {
                        text: 'Восстановить пароль',
                        active: true
                    }
                ],

                step_1: true,
                step_2: false,
                step_3: false,

                loading: false
            }
        },

        methods: {
            registerStep_1() {
                this.$v.login.$touch();
                if (this.$v.login.$invalid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте правильность внесенных данных',
                    });
                    return false;
                } else {
                    this.loading = true;
                    let url = '/api/reset-password/send-pin';
                    let params = {
                        phone: this.login
                    };
                    axios.post(url, params)
                        .then(response => {
                            if(response.status == 200) {
                                this.step_1 = false;
                                this.step_2 = true;
                            }
                        })
                        .finally(() => {
                            this.loading = false
                        })
                }
            },

            registerStep_2() {
                this.$v.login.$touch();
                this.$v.code.$touch();
                if (this.$v.login.$invalid || this.$v.code.$invalid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте правильность внесенных данных',
                    });
                    return false;
                } else {
                    this.loading = true;
                    let url = '/api/reset-password/check-pin';
                    let params = {
                        phone: this.login,
                        pin: this.code
                    };
                    axios.post(url, params)
                        .then(response => {
                            if(response.status == 200) {
                                this.step_2 = false;
                                this.step_3 = true;
                            }
                        })
                        .finally(() => {
                            this.loading = false
                        })
                }
            },

            registerStep_3() {
                this.$v.password.$touch();
                this.$v.password_confirm.$touch();
                if (this.$v.password.$invalid || this.$v.password_confirm.$invalid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте правильность внесенных данных',
                    });
                    return false;
                } else {
                    this.loading = true;

                    let url = '/api/reset-password/update-password';
                    let params = {
                        phone: this.login,
                        password: this.password,
                        password_confirm: this.password_confirm
                    };
                    axios.post(url, params)
                        .then(response => {
                            if(response.status == 200) {
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Готово',
                                    html: `Новый пароль успешно сохранен.`,
                                }).then(() => {
                                    if(response.data.access_token) localStorage.setItem('token', response.data.access_token);
                                    // this.$store.dispatch('fetchUser');
                                    window.location.pathname = "/account";
                                })
                            }
                        })
                        .finally(() => {
                            this.loading = false
                        })
                }
            },

            delayTouch($v) {
                $v.$reset();
                if (touchMap.has($v)) {
                    clearTimeout(touchMap.get($v))
                }
                touchMap.set($v, setTimeout($v.$touch, 1000))
            },

            getSeoInfo(){
                let url = '/api/seo';

                let params = {
                    url: 'reset',
                };

                axios.post(url, params)
                    .then(response => {
                        let seoInfo = response.data.seoInfo

                        document.title = seoInfo?.seo_title ? seoInfo?.seo_title : 'Восстановление пароля на сайте Фотопроката "MRental"';
                        let desc = seoInfo?.seo_desc ? seoInfo?.seo_desc : 'Восстановите пароль в личный кабинет на сайте Фотопроката "MRental" для контроля своих заказов и управление карточкой клиента.';
                        document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);
                    })
                    .catch(error => {
                        if (error) this.loading = false;
                    })
            }
        },

        mounted(){
            this.getSeoInfo();
        },

        validations: {
            login: phoneRule,
            password: passwordRule,
            password_confirm: passwordRepeatRule,
            code: requiredRule,
        }
    }
</script>
